import InputRange from './InputRange';
import inputRangeStyles from './inputRange.module.scss';
import inputRangeLabelStyles from './label.module.scss';
import sliderStyles from './slider.module.scss';
import trackStyles from './track.module.scss';

export {
  InputRange,
  inputRangeStyles,
  inputRangeLabelStyles,
  sliderStyles,
  trackStyles,
};

export default InputRange;
